import { render } from "./batch.html?vue&type=template&id=cf0f38a0&scoped=true&ts=true"
import script from "./batch.ts?vue&type=script&lang=ts"
export * from "./batch.ts?vue&type=script&lang=ts"

import "./batch.scss?vue&type=style&index=0&id=cf0f38a0&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf0f38a0"]])

export default __exports__